import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-tailwind/react";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import "./Listing.css";

const Listing = ({ list, title, Component }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <div ref={ref} className={`listing-container ${isVisible ? 'listing-visible' : ''}`}>
      <Typography variant="h3" className="listing-title">
        {title}
      </Typography>
      <div className="listing-items">
        {[...list].reverse().map((item, index) => (
          <Component key={index} {...item} animationDelay={index} />
        ))}
      </div>
    </div>
  );
};

Listing.propTypes = {
  list: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  Component: PropTypes.elementType.isRequired,
};

export default Listing;
